import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

export type UploadConfirmationAction = 'upload' | 'edit' | 'cancel';

export interface UploadConfirmationResult {
  action: UploadConfirmationAction;
}

@Component({
  selector: 'app-upload-confirmation-modal',
  templateUrl: './upload-confirmation-modal.component.html',
  styleUrls: ['./upload-confirmation-modal.component.scss'],
})
export class UploadConfirmationModalComponent implements OnInit {
  /** Number of images that were added successfully. */
  @Input() imageCount: number = 0;

  public progressWidth: string = '0%';

  constructor(
    private modalController: ModalController,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    // Animate the progress bar after a short delay
    setTimeout(() => {
      this.progressWidth = '100%';
    }, 50);
  }

  get successMessage(): string {
    return this.imageCount === 1
      ? this.translateService.instant('upload_confirmation_single_image_added')
      : this.translateService.instant(
          'upload_confirmation_multiple_images_added',
          { imageCount: this.imageCount },
        );
  }

  public onClose() {
    this.dismiss('cancel');
  }

  public onUploadDirectly() {
    this.dismiss('upload');
  }

  public onEditImages() {
    this.dismiss('edit');
  }

  private dismiss(action: UploadConfirmationAction) {
    this.modalController.dismiss({ action } as UploadConfirmationResult);
  }
}
